import React from 'react';
import cx from 'classnames';
import styles from './index.module.scss';

const ForeignAgentKrik = ({ dark = false, inline = false }) => (
	<div className={cx(styles.root, { [styles.dark]: dark, [styles.inline]: inline })}>
		<p className={styles.text}>
			18+. НАСТОЯЩИЙ МАТЕРИАЛ (ИНФОРМАЦИЯ) ПРОИЗВЕДЕН, РАСПРОСТРАНЕН И (ИЛИ) НАПРАВЛЕН ИНОСТРАННЫМ
			АГЕНТОМ ИНТЕРНЕТ-ИЗДАНИЕ «НОВАЯ ГАЗЕТА» ЛИБО КАСАЕТСЯ ДЕЯТЕЛЬНОСТИ ИНОСТРАННОГО АГЕНТА
			ИНТЕРНЕТ-ИЗДАНИЕ «НОВАЯ ГАЗЕТА».
		</p>
	</div>
);

export default ForeignAgentKrik;
